import { GetAccountRuleBindingsForQuotaDrillIn } from 'app/graphql/generated/apolloTypes';

import { SelectedAccountQuotaDrillInCell } from 'app/models';

export interface AccountQuotaDrillInRow extends SelectedAccountQuotaDrillInCell {
  accountName: string;
  accountQuota: number;
}

export const formatBindingsAsDrillInRows = (
  accountRuleBindings: GetAccountRuleBindingsForQuotaDrillIn,
  measureId: number
): AccountQuotaDrillInRow[] => {
  return accountRuleBindings.getAccountRuleBindings.bindings.map((binding) => {
    const { hierarchyId, name, key } = binding.hierarchy;
    return {
      accountKey: key,
      accountId: hierarchyId,
      accountName: name,
      accountQuota: binding.measures?.[0]?.measureValue || 0,
      measureId
    };
  });
};
